// extracted by mini-css-extract-plugin
module.exports = {"eliteFaqWrapper":"_2x2YO"};